import { AfterViewInit, Component, HostListener, OnDestroy, OnInit, inject } from "@angular/core";
import { FormControl, FormGroup, FormsModule, NonNullableFormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import _ from "lodash";
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzDrawerModule } from "ng-zorro-antd/drawer";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzInputDirective, NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageModule, NzMessageService } from "ng-zorro-antd/message";
import { NzPageHeaderModule } from "ng-zorro-antd/page-header";
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpaceModule } from "ng-zorro-antd/space";
import { NzTableModule } from "ng-zorro-antd/table";
import { Subject, takeUntil } from "rxjs";
import { UserLoggedService } from "src/app/core/services/userLogged.service";
import { ArticleFamilyDto } from "src/app/shared/dto/article-family.dto";
import { ArticleTypeDto } from "src/app/shared/dto/article-type.dto";
import { ArticleDto } from "src/app/shared/dto/article.dto";
import { MachineMeasurementsValueDto } from "src/app/shared/dto/machine-measurements-value.dto";
import { MachineMeasurementDto } from "src/app/shared/dto/machine-measurements.dto";
import { MachineDto } from "src/app/shared/dto/machine.dto";
import { MeasurementUnitDto } from "src/app/shared/dto/measurement-unit.dto";
import { UserDto } from "src/app/shared/dto/user.dto";
import { ArticleFamilyService } from "../../services/article-family.service";
import { ArticleTypeService } from "../../services/article-type.service";
import { ArticlesService } from "../../services/articles.service";
import { MachineMeasurementsValueService } from "../../services/machine-measurements-value.service";
import { MachineMeasurementsService } from "../../services/machine-measurements.service";
import { MachineService } from "../../services/machine.service";
import { MeasurementunitsService } from "../../services/measurementunits.service";
import { NzIconModule, NzIconService } from "ng-zorro-antd/icon";
import { DrawerMode } from "src/app/core/enums/drawer-mode";
import { DRAWER_WIDTH_CHANGE_PLACEMENT } from "src/app/core/constants/components";
import { NzFormDirective, NzFormItemComponent, NzFormControlComponent, NzFormModule } from "ng-zorro-antd/form";
import { NzRowDirective, NzColDirective } from "ng-zorro-antd/grid";
import { IconDefinition } from "@ant-design/icons-angular";
import { PlusOutline } from "@ant-design/icons-angular/icons";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { DefaultComponent } from "src/app/shared/services/view.service";
import { LoaderComponent } from "src/app/shared/components/loader/loader.component";
import { ProductionProcessesService } from "../../services/production-processes.service";
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { ProductionProcessDto } from "src/app/shared/dto/production-process.dto";
import { ArticleBatchesService } from "../../services/article-batches.service";
import { ArticleBatchDto } from "src/app/shared/dto/article-batch.dto";
import { NzButtonModule } from "ng-zorro-antd/button";
import { ArticleFeatureValueDto } from "src/app/shared/dto/article-feature-value.dto";
import { ArticleFeatureDto } from "src/app/shared/dto/article-feature.dto";
import { ArticleFeaturesService } from "../../services/article-features.service";
import { makeid } from "src/app/shared/utils/utils";
import { NzSwitchModule } from 'ng-zorro-antd/switch';
const icons: IconDefinition[] = [
    PlusOutline
];
@Component({
    selector: 'app-articles',
    templateUrl: './articles.component.html',
    styleUrl: './articles.component.scss',
    standalone: true,
    imports: [
        NzPageHeaderModule,
        NzSpaceModule,
        NzDividerModule,
        NzDrawerModule,
        NzDatePickerModule,
        FormsModule,
        NzMessageModule,
        NzTableModule,
        NzSelectModule,
        NzInputDirective,
        ReactiveFormsModule,
        NzFormDirective,
        NzRowDirective,
        NzFormItemComponent,
        NzColDirective,
        NzFormControlComponent,
        NzInputModule,
        NzFormModule,
        NzIconModule,
        NzCheckboxModule,
        NzDropDownModule,
        NzToolTipModule,
        LoaderComponent,
        NzTabsModule,
        NzButtonModule,
        NzSwitchModule
    ]
})
export class ArticlesComponent extends DefaultComponent implements OnInit, AfterViewInit, OnDestroy {

    articles: ArticleDto[] = [];
    filteredArticles: ArticleDto[] = [];
    searchText: string = '';
    fieldsReadOnly: boolean = true;
    drawerTitle: string = 'Placeholder';
    drawerMode!: DrawerMode;
    drawerVisible: boolean = false;
    articleSelected: ArticleDto = new ArticleDto();
    createdAt: Date = new Date();
    updatedAt: Date = new Date();
    currentUser: UserDto = new UserDto();
    articleActive: boolean = false;
    articleUseBatches: boolean = false;
    isLoading: boolean = true;
    isSaving: boolean = false;
    DrawerMode = DrawerMode;

    measurementUnits: MeasurementUnitDto[] = [];
    measurementUnitSelected: MeasurementUnitDto = new MeasurementUnitDto();

    articleFamilyDto: ArticleFamilyDto[] = [];
    articleFamiliesSelected: ArticleFamilyDto[] = [];

    articleTypeDto: ArticleTypeDto[] = [];
    articleTypeSelected: ArticleTypeDto = new ArticleTypeDto();

    machineMeasurements: MachineMeasurementDto[] = [];
    machineMeasurementsSelected: MachineMeasurementDto | null = null;

    machineMeasurementsValues: MachineMeasurementsValueDto[] = [];
    machineMeasurementsValueSelected: MachineMeasurementsValueDto[] = [];
    machineMeasurementsValueAdding: MachineMeasurementsValueDto = new MachineMeasurementsValueDto();

    machines: MachineDto[] = [];
    machineSelected: MachineDto | null = null;

    productionProcesses: ProductionProcessDto[] = [];
    productionProcessSelected: ProductionProcessDto | null = null;

    articleBatchesSelected: ArticleBatchDto [] = [];

    articleFeatureValues: ArticleFeatureValueDto[] = [];
    articleFeatureValuesSelected: ArticleFeatureValueDto[] = [];
    articleFeatureValueAdding: ArticleFeatureValueDto = new ArticleFeatureValueDto();

    articleFeatures: ArticleFeatureDto[] = [];
    articleFeatureSelected: ArticleFeatureDto | null = null;

    innerWidth: number = 0;
    DRAWER_WIDTH_CHANGE_PLACEMENT = DRAWER_WIDTH_CHANGE_PLACEMENT;

    validateForm: FormGroup<{
        name: FormControl<string>;
        ean: FormControl<string>;
        externalReference: FormControl<string>;
        alias: FormControl<string>;
        active: FormControl<boolean>;
        useBatches: FormControl<boolean>;
        quantity: FormControl<number>;
    }>;

    private readonly articlesService = inject(ArticlesService);
    private readonly message = inject(NzMessageService);
    private readonly userLoggedService = inject(UserLoggedService);
    private readonly measurementUnitService = inject(MeasurementunitsService);
    private readonly articleFamilyService = inject(ArticleFamilyService);
    private readonly articleTypeService = inject(ArticleTypeService);
    private readonly machineMeasurementsService = inject(MachineMeasurementsService);
    private readonly machineMeasurementsValueService = inject(MachineMeasurementsValueService);
    private readonly machinesService = inject(MachineService);
    private readonly fb = inject(NonNullableFormBuilder);
    private readonly iconService = inject(NzIconService);
    private readonly productionProcessessService = inject(ProductionProcessesService);
    private readonly articleBatchesService = inject(ArticleBatchesService);
    private readonly articleFeaturesService = inject(ArticleFeaturesService);

    private unsubscribe$ = new Subject<void>();

    constructor() {
        super('articles', '');
        this.validateForm = this.fb.group({
            name: ['', [Validators.required]],
            ean: ['', [Validators.required]],
            externalReference: ['', [Validators.required]],
            alias: [''],
            active: [true],
            useBatches: [false],
            quantity: [0, [Validators.required]]
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.innerWidth = window.innerWidth;
    }

    async ngOnInit() {
        this.currentUser = this.userLoggedService.userLogged;
        this.innerWidth = window.innerWidth;
        this.iconService.addIcon(...icons);

        await this.articlesService.setupWebSocket();
        this.articlesService.articles$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (articles) => {
                    this.articles = articles;
                    this.filterArticles();
                    this.articleSelected = this.articles.find(article => article.id === this.articleSelected.id) || new ArticleDto();
                    this.measurementUnitSelected = this.measurementUnits.find((m) => m.id === this.articleSelected.measurementUnitId) || new MeasurementUnitDto();
                    this.articleTypeSelected = this.articleTypeDto.find((t) => t.id === this.articleSelected.articleTypeId) || new ArticleTypeDto();
                    this.articleActive = this.articleSelected.active;
                    this.articleFamiliesSelected = this.articleFamilyDto.filter(family => this.articleSelected.families?.map(f => f.familyId).includes(family.id));
                    this.articleUseBatches = this.articleSelected.useBatches ?? false;
                },
                error: () => {
                    this.message.error('Error cargando artículos');
                }
            });

        await this.measurementUnitService.setupWebSocket();
        this.measurementUnitService.measurementUnits$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (measures) => {
                    this.measurementUnits = measures;
                    if (this.measurementUnits.length > 0) {
                        this.measurementUnitSelected = this.measurementUnits[0];
                    } else {
                        this.measurementUnitSelected = new MeasurementUnitDto();
                    }
                },
                error: () => {
                    this.message.error('Error cargando unidades de medida');
                }
            });


        await this.articleFamilyService.setupWebSocket();
        this.articleFamilyService.articleFamilies$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (families) => {
                    this.articleFamilyDto = families;
                },
                error: () => {
                    this.message.error('Error cargando familias de artículo');
                }
            });

        await this.articleTypeService.setupWebSocket();
        this.articleTypeService.articleTypes$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (types) => {
                    this.articleTypeDto = types;
                    if (this.articleTypeDto.length > 0) {
                        this.articleTypeSelected = this.articleTypeDto[0];
                    } else {
                        this.articleTypeSelected = new ArticleTypeDto();
                    }
                },
                error: () => {
                    this.message.error('Error cargando tipos de artículo');
                }
            });

        await this.machineMeasurementsService.setupWebSocket();
        this.machineMeasurementsService.machineMeasurements$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (machineMeasurements) => {
                    this.machineMeasurements = machineMeasurements;
                },
                error: () => {
                    this.message.error('Error cargando medidas de máquina');
                }
            });

        await this.machineMeasurementsValueService.setupWebSocket();
        this.machineMeasurementsValueService.machineMeasurementsValues$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (machineMeasurementsValues) => {
                    this.machineMeasurementsValues = machineMeasurementsValues;
                },
                error: () => {
                    this.message.error('Error cargando valores de medidas de máquina');
                }
            });

        await this.machinesService.setupWebSocket();
        this.machinesService.machines$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (machines) => {
                    this.machines = machines;
                },
                error: () => {
                    this.message.error('Error cargando máquinas');
                }
            });

        await this.productionProcessessService.setupWebSocket();
        this.productionProcessessService.productionProcessess$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (productionProcesses) => {
                    this.productionProcesses = productionProcesses;
                },
                error: () => {
                    this.message.error('Error cargando procesos productivos');
                }
            });

        await this.articleFeaturesService.setupWebSocket();
        this.articleFeaturesService.articleFeatures$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (articleFeatures) => {
                    this.articleFeatures = articleFeatures;
                },
                error: () => {
                    this.message.error('Error cargando características de artículos');
                }
            });

        this.isLoading = false;
    }

    ngAfterViewInit() {
        this.innerWidth = window.innerWidth;
    }

    ngOnDestroy(): void {
        this.articlesService.disconnectWebSocket();
        this.measurementUnitService.disconnectWebSocket();
        this.articleFamilyService.discontectWebSocket();
        this.articleTypeService.disconnectWebSocket();
        this.machineMeasurementsService.disconnectWebSocket();
        this.machineMeasurementsValueService.disconnectWebSocket();
        this.machinesService.disconnectWebSocket();
        this.productionProcessessService.disconnectWebSocket();
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    filterArticles(): void {
        const term = this.searchText.trim().toLowerCase();

        if (!term) {
            this.filteredArticles = [...this.articles];
            return;
        }

        this.filteredArticles = this.articles.filter((article) => {
            const matchesId = article.id?.toString().includes(term);
            const matchesExternalId = article.externalId?.toString().includes(term);
            const matchesName = article.name?.toLowerCase().includes(term);
            const matchesEan = article.ean?.toLowerCase().includes(term);

            return matchesId || matchesExternalId || matchesName || matchesEan;
        });
    }

    create() {
        this.articleSelected = new ArticleDto();
        this.articleFamiliesSelected = [];
        this.articleTypeSelected = this.articleTypeDto[0] || new ArticleTypeDto();
        this.machineMeasurementsValueSelected = [];
        this.validateForm.enable();

        this.drawerMode = DrawerMode.CREATE;
        this.drawerTitle = 'Creando nuevo artículo';
        this.fieldsReadOnly = false;
        this.openDrawer();
    }

    async view(data: ArticleDto) {
        this.validateForm.patchValue(data);
        this.validateForm.disable();
        this.articleSelected = data;

        this.drawerMode = DrawerMode.VIEW;
        this.drawerTitle = `Viendo artículo ${this.articleSelected?.name}`;
        this.fieldsReadOnly = true;
        await this.setData();
        this.openDrawer();
    }

    async edit(data: ArticleDto) {
        this.validateForm.patchValue(data);
        this.validateForm.enable();
        this.articleSelected = data;

        if(this.articleSelected.useBatches){
            this.validateForm.controls.quantity.disable();
        }

        this.drawerMode = DrawerMode.EDIT;
        this.drawerTitle = `Editando artículo ${this.articleSelected?.name}`;
        this.fieldsReadOnly = false;
        await this.setData();
        this.openDrawer();
    }

    delete(id: number) {
        if (window.confirm('¿Estás seguro de que quieres eliminar este artículo? Esta acción no se puede deshacer.')) {
            this.articlesService.delete(id).subscribe({
                next: (article: ArticleDto) => {
                    try {
                        if (article == undefined) {
                            throw new Error('Article not found');
                        }

                        const index = this.articles.findIndex((a) => a.id === id);

                        if (index < 0) {
                            this.message.create('error', `No se ha podido eliminar el articulo ${article.name} con id ${id}, artículo no encontrado`);
                            throw new Error('Article not found');
                        }

                        this.articles.splice(index, 1);
                        const data = [...this.articles];
                        this.articles = data;
                        this.filterArticles();

                        this.message.create('success', 'Artículo eliminado correctamente');
                    } catch (error) {
                        console.error(error);
                        this.message.create('error', 'Error al eliminar el artículo');
                    }
                },
                error: (error) => {
                    console.error(error);
                    this.message.create('error', 'Error al eliminar el artículo, error de servidor');
                }
            });
        } else {
            console.log(`Cancelando eliminación de artículo ${id}`);
        }
    }

    async setData() {
        this.articleActive = this.articleSelected.active;
        this.articleUseBatches = this.articleSelected.useBatches ? this.articleSelected.useBatches : false;
        this.measurementUnitSelected = this.measurementUnits.find((m) => m.id === this.articleSelected.measurementUnitId) as MeasurementUnitDto;
        this.articleTypeSelected = this.articleTypeDto.find((t) => t.id === this.articleSelected.articleTypeId) as ArticleTypeDto;

        if (this.articleSelected.families) {
            const familiesIds: number[] = this.articleSelected.families.map((f) => f.familyId);
            this.articleFamiliesSelected = this.articleFamilyDto.filter((f) => familiesIds.includes(f.id));
        } else {
            this.articleFamiliesSelected = [];
        }

        if (this.articleSelected.machineMeasurementsValues != null && this.articleSelected.machineMeasurementsValues.length > 0) {
            this.machineMeasurementsValueSelected = this.articleSelected.machineMeasurementsValues;

            for (const mmv of this.machineMeasurementsValueSelected) {
                mmv.frontId = makeid(10);
            }
        }

        if (this.articleSelected.articleFeatureValues != null && this.articleSelected.articleFeatureValues.length > 0) {
            this.articleFeatureValuesSelected = this.articleSelected.articleFeatureValues;

            for (const afv of this.articleFeatureValuesSelected) {
                afv.frontId = makeid(10);
            }
        }

        if(this.drawerMode !== DrawerMode.CREATE){
            this.articleBatchesSelected = await this.articleBatchesService.getBatchesByArticleId(this.articleSelected.id);
        }
    }

    openDrawer() {
        this.drawerVisible = true;
    }

    closeDrawer() {
        this.articleFamiliesSelected = [];
        this.articleTypeSelected = this.articleTypeDto[0] || new ArticleTypeDto();
        this.machineMeasurementsSelected = null;
        this.machineMeasurementsValueSelected = [];
        this.machineSelected = null;
        this.productionProcessSelected = null;
        this.articleBatchesSelected = [];
        this.articleFeatureValuesSelected = [];
        this.articleFeatureSelected = null;
        this.articleFeatureValueAdding.value = '';
        this.validateForm.reset();
        this.drawerVisible = false;
    }

    submitForm() {
        this.isSaving = true;

        const customArticleDto: ArticleDto = {
            id: this.articleSelected.id,
            name: this.validateForm.controls.name.value ? this.validateForm.controls.name.value : '',
            ean: this.validateForm.controls.ean.value ? this.validateForm.controls.ean.value.toString() : '',
            alias: this.validateForm.controls.alias.value ? this.validateForm.controls.alias.value : '',
            externalReference: this.validateForm.controls.externalReference.value ? this.validateForm.controls.externalReference.value : '',
            quantity: this.validateForm.controls.quantity.value ? this.validateForm.controls.quantity.value : 0,
            active: this.validateForm.controls.active.value,
            useBatches: this.validateForm.controls.useBatches.value,
            batchControl: this.validateForm.controls.useBatches.value,
            measurementUnit: this.measurementUnitSelected,
            familiesIds: this.articleFamiliesSelected.map((f) => f.id),
            articleType: this.articleTypeSelected,
            machineMeasurementsValues: [],
            articleFeatureValues: []
        };

        if (!this.validForm(customArticleDto)) {
            this.isSaving = false;
            return;
        }

        if (this.machineMeasurementsValueSelected.length > 0) {
            customArticleDto.machineMeasurementsValues = _.cloneDeep(this.machineMeasurementsValueSelected);

            for (const mmv of customArticleDto.machineMeasurementsValues) {
                mmv.frontId = undefined;
            }
        }

        if (this.articleFeatureValuesSelected.length > 0) {
            customArticleDto.articleFeatureValues = _.cloneDeep(this.articleFeatureValuesSelected);

            for (const afv of customArticleDto.articleFeatureValues) {
                afv.frontId = undefined;
            }
        }

        if (this.drawerMode === DrawerMode.CREATE) {
            this.articlesService.save(customArticleDto).subscribe({
                next: (article: ArticleDto) => {
                    try {
                        if (article == undefined) {
                            this.isSaving = false;
                            throw new Error('Error creating article');
                        }

                        this.articles.push(article);
                        const data = [...this.articles];
                        this.articles = data;
                        this.filterArticles();

                        this.isSaving = false;
                        this.message.create('success', 'Artículo creado correctamente');
                        this.closeDrawer();
                    } catch (error) {
                        console.error('Error creating article', error);
                        this.isSaving = false;
                        this.message.create('error', 'Error al crear el artículo');
                    }
                },
                error: (error) => {
                    console.error('Error creating article', error);
                    this.isSaving = false;
                    this.message.create('error', 'Error al crear el artículo, error de servidor');
                }
            });
        } else if (this.drawerMode === DrawerMode.EDIT) {
            this.articlesService.update(customArticleDto.id, customArticleDto).subscribe({
                next: (article: ArticleDto) => {
                    try {
                        if (article == undefined) {
                            this.isSaving = false;
                            throw new Error('Error updating article');
                        }

                        const index = this.articles.findIndex((a) => a.id === article.id);

                        if (index < 0) {
                            this.isSaving = false;
                            this.message.create('error', `No se ha podido actualizar el articulo ${customArticleDto.name} con id ${customArticleDto.id}, artículo no encontrado`);
                            throw new Error('Article not found');
                        }

                        this.articles[index] = article;
                        const data = [...this.articles];
                        this.articles = data;
                        this.filterArticles();

                        this.isSaving = false;
                        this.message.create('success', 'Artículo actualizado correctamente');
                        this.closeDrawer();
                    } catch (error) {
                        console.error('Error updating articles', error);
                        this.isSaving = false;
                        this.message.create('error', 'Error al actualizar el artículo');
                    }
                },
                error: (error) => {
                    console.error('Error updating articles', error);
                    this.isSaving = false;
                    this.message.create('error', 'Error al actualizar el artículo, error de servidor');
                }
            });
        }
    }

    cancelEditing() {
        this.closeDrawer();
    }

    validForm(article: ArticleDto): boolean {
        if (!article.name) {
            this.message.create('error', 'El nombre del artículo es obligatorio');
            return false;
        }

        if (!article.ean) {
            this.message.create('error', 'El EAN del artículo es obligatorio');
            return false;
        }

        if (!article.externalReference) {
            this.message.create('error', 'La referencia externa del artículo es obligatoria');
            return false;
        }

        if (article.quantity === undefined || article.quantity === null) {
            this.message.create('error', 'La cantidad del artículo es obligatoria');
            return false;
        }

        return true;
    }

    compareById(o1: any, o2: any): boolean {
        return o1 && o2 ? o1.id === o2.id : o1 === o2;
    }

    changeType(id: number) {
        this.articleTypeSelected = this.articleTypeDto.find((t) => t.id === id) as ArticleTypeDto;
    }

    addEntryMachineMeasurement() {

        if (!this.machineSelected) {
            this.message.create('error', 'Seleccione una máquina');
            return;
        }

        if (!this.machineMeasurementsSelected) {
            this.message.create('error', 'Seleccione un valor de máquina');
            return;
        }

        if (!this.machineMeasurementsValueAdding.value || this.machineMeasurementsValueAdding.value === '') {
            this.message.create('error', 'El valor de la medida es obligatorio');
            return;
        }

        const measurement: string = this.machineMeasurements.find((m) => m.id === this.machineMeasurementsSelected!.id)?.measurement as string;

        this.machineMeasurementsValueAdding.articleId = this.articleSelected.id;
        this.machineMeasurementsValueAdding.machineId = this.machineSelected.id;
        this.machineMeasurementsValueAdding.machine = _.cloneDeep(this.machineSelected);
        this.machineMeasurementsValueAdding.machineMeasurementId = this.machineMeasurementsSelected.id as number;
        this.machineMeasurementsValueAdding.machineMeasurement = _.cloneDeep(this.machineMeasurementsSelected);
        if(this.productionProcessSelected){
            this.machineMeasurementsValueAdding.productionProcessId = this.productionProcessSelected.id;
            this.machineMeasurementsValueAdding.productionProcess = _.cloneDeep(this.productionProcessSelected);
        }


        if (!this.machineMeasurementsValueAdding.id) {
            this.machineMeasurementsValueAdding.frontId = makeid(10);
        }

        const machineMeasurementsValueAddingClone = _.cloneDeep(this.machineMeasurementsValueAdding);

        const data = [...this.machineMeasurementsValueSelected];
        data.push(machineMeasurementsValueAddingClone);
        this.machineMeasurementsValueSelected = data;

        this.machineMeasurementsSelected = null;
        this.machineSelected = null;
        this.productionProcessSelected = null;
        this.machineMeasurementsValueAdding.value = '';
    }

    addEntryArticleFeature() {

        if (!this.articleFeatureSelected) {
            this.message.create('error', 'Seleccione una característica de artículo');
            return;
        }

        if (!this.articleFeatureValueAdding.value || this.articleFeatureValueAdding.value === '') {
            this.message.create('error', 'El valor de la característica es obligatorio');
            return;
        }

        this.articleFeatureValueAdding.articleId = _.cloneDeep(this.articleSelected.id);
        this.articleFeatureValueAdding.featureId = _.cloneDeep(this.articleFeatureSelected.id);
        this.articleFeatureValueAdding.article = _.cloneDeep(this.articleSelected);
        this.articleFeatureValueAdding.feature = _.cloneDeep(this.articleFeatureSelected);

        if (!this.articleFeatureValueAdding.id) {
            this.articleFeatureValueAdding.frontId = makeid(10);
        }

        const articleFeatureValueAddingClone = _.cloneDeep(this.articleFeatureValueAdding);

        const data = [...this.articleFeatureValuesSelected];
        data.push(articleFeatureValueAddingClone);
        this.articleFeatureValuesSelected = data;

        this.articleFeatureSelected = null;
        this.articleFeatureValueAdding.value = '';
    }

    deleteEntryMachineMeasurement(id: string | undefined) {
        if (!id) {
            this.message.create('error', 'Error al eliminar valor de medida de máquina');
            return;
        }

        const data = this.machineMeasurementsValueSelected.filter((mmv) => mmv.frontId! !== id);
        this.machineMeasurementsValueSelected = data;
    }

    deleteEntryArticleFeature(id: string | undefined) {
        if (!id) {
            this.message.create('error', 'Error al eliminar característica de artículo');
            return;
        }

        const data = this.articleFeatureValuesSelected.filter((af) => af.frontId !== id);
        this.articleFeatureValuesSelected = data;
    }

    compareArticleFamilies = (o1: any, o2: any): boolean => {
        return o1 && o2 ? o1.id === o2.id : o1 === o2;
    };

    isDisabledArticleFeature(articleFeatureId: number): boolean {
        const existingArticle: ArticleFeatureValueDto | undefined = this.articleFeatureValuesSelected ? this.articleFeatureValuesSelected.find(af => af.featureId === articleFeatureId) : undefined;

        return existingArticle !== undefined;
    }
}
